import type { ClientLegalTextAcceptRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedLegalApi } from '@/features/api/hooks/shared-legal/useSharedLegalApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useAcceptLegalTexts = () => {
  const queryClient = useQueryClient();
  const api = useSharedLegalApi();

  return useApiMutation({
    mutationFn: (clientLegalTextAcceptRequest: ClientLegalTextAcceptRequest) =>
      api.acceptLegalTexts({ clientLegalTextAcceptRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.LEGAL_TEXT_STATUS]
      });
      /*
        Todo: invalidation here causes some unsent requests during registration. As we do not use the onboarding endpoint during the app, this might be fine
        queryClient.invalidateQueries({
          queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS]
        });
    */
    },
    onError: (e) => console.error('[Terms] accepting terms failed:', e)
  });
};
